import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { analyzeData } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "analyzeDataExport",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      exportdataloading: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (!this.paramsData.amount) {
        this.$message.error(this.$t('pleaseInputRechargeAmount'));
        return;
      }

      this.searchData.page = e;
      this.reqLoading = true;

      if (this.value2.length > 0) {
        this.searchData.start_time = this.value2[0];
        this.searchData.end_time = this.value2[1];
      }

      analyzeData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        server_id: this.paramsData.server_id,
        amount: this.paramsData.amount
      })).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;
          var list = _this.rawData.game_mark.indexOf('royalpirates') > -1 ? _this.serverList : _this.serverListYJ;

          _this.tableData.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataloading = true;
      analyzeData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        server_id: this.paramsData.server_id,
        amount: this.paramsData.amount,
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var list = _this2.rawData.game_mark.indexOf('royalpirates') > -1 ? _this2.serverList : _this2.serverListYJ;
          data.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          var columns = [{
            label: _this2.$t('nameLabel'),
            prop: "role_name"
          }, {
            label: _this2.$t('serverId'),
            prop: "server_id"
          }, {
            label: _this2.$t('serverName'),
            prop: "server_name"
          }, {
            label: _this2.$t('currentLevel'),
            prop: "level"
          }, {
            label: _this2.$t('fightingPower'),
            prop: "fighting"
          }, {
            label: _this2.$t('userTotalRechargeAmountLabel'),
            prop: "total_amount"
          }, {
            label: _this2.$t('userId'),
            prop: "user_id_str"
          }, {
            label: _this2.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this2.$t('lastLoginDate'),
            prop: "last_login_date"
          }, {
            label: _this2.$t('lastLoginTime'),
            prop: "last_login_time"
          }, {
            label: _this2.$t('userRegisterDate'),
            prop: "register_date"
          }, {
            label: _this2.$t('userRegisterTimeLabel'),
            prop: "register_time"
          }, {
            label: _this2.$t('taskDate'),
            prop: "task_date"
          }, {
            label: _this2.$t('taskTime'),
            prop: "task_time"
          }, {
            label: _this2.$t('lastLevel'),
            prop: "task"
          }, {
            label: _this2.$t('whichLevel'),
            prop: "task_sub"
          }];

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataloading = false;
      });
    }
  }
};